import type {
  CreateItemInput,
  UpdateItemInput,
  ItemResponse,
  PaginatedResponse,
  Category,
} from '@collector/shared'
import apiClient from './client'

export interface GetItemsOptions {
  page?: number
  limit?: number
  category?: Category
  isVirtual?: boolean
  search?: string
  sortBy?: 'createdAt' | 'artistOrManufacturer' | 'location' | 'category'
  sortOrder?: 'asc' | 'desc'
  tag?: string
}

export async function getItems(
  options?: GetItemsOptions
): Promise<PaginatedResponse<ItemResponse>> {
  const params = new URLSearchParams()
  if (options?.page) params.append('page', String(options.page))
  if (options?.limit) params.append('limit', String(options.limit))
  if (options?.category) params.append('category', options.category)
  if (options?.isVirtual !== undefined) params.append('isVirtual', String(options.isVirtual))
  if (options?.search) params.append('search', options.search)
  if (options?.sortBy) params.append('sortBy', options.sortBy)
  if (options?.sortOrder) params.append('sortOrder', options.sortOrder)
  if (options?.tag) params.append('tag', options.tag)

  const queryString = params.toString()
  const response = await apiClient.get<PaginatedResponse<ItemResponse>>(
    `/items${queryString ? '?' + queryString : ''}`
  )
  return response.data
}

export async function createItem(data: CreateItemInput): Promise<ItemResponse> {
  const response = await apiClient.post<ItemResponse>('/items', data)
  return response.data
}

export async function uploadItemImage(itemId: number, file: File): Promise<ItemResponse> {
  const formData = new FormData()
  formData.append('image', file)

  const response = await apiClient.post<ItemResponse>(`/items/${itemId}/images`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return response.data
}

export async function getItem(id: number): Promise<ItemResponse> {
  const response = await apiClient.get<ItemResponse>(`/items/${id}`)
  return response.data
}

export async function updateItem(id: number, data: UpdateItemInput): Promise<ItemResponse> {
  const response = await apiClient.patch<ItemResponse>(`/items/${id}`, data)
  return response.data
}

export async function deleteItem(id: number): Promise<void> {
  await apiClient.delete(`/items/${id}`)
}
